<template lang="html">

    <section class="buscador row-start">

        <nav class="breadcrumb">
            <router-link :to="$t('enlaces.home')">Inicio</router-link>
            <router-link :to="$t('enlaces.home')">Ofertas ESIC</router-link>
        </nav>


        <template v-if="!showfull">

            <div class="select column-start -options-wrapper" :open="showoptions['areafuncional']">
                <label for="areafuncional">Área funcional</label>
                <p @click="toggleOptions('areafuncional')" class="fake-select" selected="selected"
                    v-if="filtrosstring.areafuncional.length > 0">{{filtrosstring.areafuncional | list}}</p>
                <p @click="toggleOptions('areafuncional')" class="fake-select" v-else>Seleccionar área funcional</p>
                <div class="options-container" v-if="showoptions['areafuncional']"
                    @mouseleave="closeOptions('areafuncional')">
                    <div class="check" v-for="tipo in dominiosorder.areafuncional">
                        <input type="checkbox" :id="'areafuncional-'+tipo[0]" v-model="filtros.areafuncional"
                            :value="tipo[0]" name="areafuncional">
                        <label :for="'areafuncional-'+tipo[0]">{{tipo[1]}} ({{lengthbydomain['areafuncional'][tipo[0]]}})</label>
                    </div>
                </div>
            </div>

            <div class="select column-start -options-wrapper" :open="showoptions['experiencia']" v-if="hasExperiencias">
                <label for="categoriaprofesional">Experiencia</label>
                <p @click="toggleOptions('experiencia')" class="fake-select" selected="selected"
                    v-if="filtrosstring.experiencia.length > 0">{{filtrosstring.experiencia | list}}</p>
                <p @click="toggleOptions('experiencia')" class="fake-select" v-else>Seleccionar experiencia</p>
                <div class="options-container" v-if="showoptions['experiencia']" @mouseleave="closeOptions('experiencia')">
                    <div class="check" v-for="tipo in dominiosorder.experiencia">
                        <input type="checkbox" :id="'sector-'+tipo[0]" v-model="filtros.experiencia" :value="tipo[0]"
                            name="sector">
                        <label :for="'sector-'+tipo[0]">{{tipo[1]}} ({{lengthbydomain['experiencia'][tipo[0]]}})</label>
                    </div>
                </div>
            </div>

            <div class="select column-start -options-wrapper" :open="showoptions['ubicacion']">
                <label for="ubicacion">Ubicación</label>
                <p @click="toggleOptions('ubicacion')" class="fake-select" selected="selected"
                    v-if="filtrosstring.ubicacion.length > 0">{{filtrosstring.ubicacion | list}}</p>
                <p @click="toggleOptions('ubicacion')" class="fake-select" v-else>Seleccionar ubicación</p>
                <div class="options-container" v-if="showoptions['ubicacion']" @mouseleave="closeOptions('ubicacion')">
                    <div class="check" v-for="ubicacion in ubicaciones">
                        <input type="checkbox" :id="'ubicacion-'+ubicacion" v-model="filtros.ubicacion"
                            :value="ubicacion" name="ubicacion">
                        <label :for="'ubicacion-'+ubicacion">{{ubicacion}} ({{lengthbydomain['ubicaciones'][ubicacion]}})</label>
                    </div>
                </div>
            </div>

            <div class="select column-start" v-if="!hasExperiencias">
                <label for="palabrasclave">Palabras clave</label>
                <input type="text" id="palabrasclave" placeholder="Palabras de búsqueda"
                    v-model="filtros.palabrasclave" :selected="!!filtros.palabrasclave">
            </div>

            <a class="link" @click="showfull = true">Todos los filtros</a>


        </template>


        <template v-if="showfull">

            <div class="top row-between">

                <h2>Todos los filtros</h2>

                <div class="row-end">
                    <a class="btn skull" v-if="filtroslength > 0" @click="erasefiltros">Limpiar filtros
                        ({{(filtroslength > 0) ? filtroslength : ''}})</a>
                    <a @click="showfull = false" class="btn">Buscar ({{length}})</a>
                    <a @click="closefiltro" class="link">Cancelar</a>
                </div>

            </div>

            <div class="bottom row-start">


                <div class="select column-start -options-wrapper" :open="showoptions['areafuncional']">
                    <label for="areafuncional">Área funcional</label>
                    <p @click="toggleOptions('areafuncional')" class="fake-select" selected="selected"
                        v-if="filtrosstring.areafuncional.length > 0">{{filtrosstring.areafuncional | list}}</p>
                    <p @click="toggleOptions('areafuncional')" class="fake-select" v-else>Seleccionar área funcional</p>
                    <div class="options-container" v-if="showoptions['areafuncional']"
                        @mouseleave="closeOptions('areafuncional')">
                        <div class="check" v-for="tipo in dominiosorder.areafuncional">
                            <input type="checkbox" :id="'areafuncional-'+tipo[0]" v-model="filtros.areafuncional"
                                :value="tipo[0]" name="areafuncional">
                            <label :for="'areafuncional-'+tipo[0]">{{tipo[1]}}
                                ({{lengthbydomain['areafuncional'][tipo[0]]}})</label>
                        </div>
                    </div>
                </div>



                <div class="select column-start -options-wrapper" :open="showoptions['experiencia']" v-if="hasExperiencias">
                    <label for="categoriaprofesional">Experiencia</label>
                    <p @click="toggleOptions('experiencia')" class="fake-select" selected="selected"
                        v-if="filtrosstring.experiencia.length > 0">{{filtrosstring.experiencia | list}}</p>
                    <p @click="toggleOptions('experiencia')" class="fake-select" v-else>Seleccionar experiencia</p>
                    <div class="options-container" v-if="showoptions['experiencia']"
                        @mouseleave="closeOptions('experiencia')">
                        <div class="check" v-for="tipo in dominiosorder.experiencia">
                            <input type="checkbox" :id="'sector-'+tipo[0]" v-model="filtros.experiencia" :value="tipo[0]"
                                name="sector">
                            <label :for="'sector-'+tipo[0]">{{tipo[1]}}
                                ({{lengthbydomain['experiencia'][tipo[0]]}})</label>
                        </div>
                    </div>
                </div>


                <div class="select column-start -options-wrapper" :open="showoptions['ubicacion']">
                    <label for="ubicacion">Ubicación</label>
                    <p @click="toggleOptions('ubicacion')" class="fake-select" selected="selected"
                        v-if="filtrosstring.ubicacion.length > 0">{{filtrosstring.ubicacion | list}}</p>
                    <p @click="toggleOptions('ubicacion')" class="fake-select" v-else>Seleccionar ubicación</p>
                    <div class="options-container" v-if="showoptions['ubicacion']"
                        @mouseleave="closeOptions('ubicacion')">
                        <div class="check" v-for="ubicacion in ubicaciones">
                            <input type="checkbox" :id="'ubicacion-'+ubicacion" v-model="filtros.ubicacion"
                                :value="ubicacion" name="ubicacion">
                            <label :for="'ubicacion-'+ubicacion">{{ubicacion}}
                                ({{lengthbydomain['ubicaciones'][ubicacion]}})</label>
                        </div>
                    </div>
                </div>



                <div class="select column-start -options-wrapper" :open="showoptions['contratos']">
                    <label for="contratos">Tipo de contrato</label>
                    <p @click="toggleOptions('contratos')" class="fake-select"
                        v-if="filtrosstring.contratos.length > 0">{{filtrosstring.contratos | list}}</p>
                    <p @click="toggleOptions('contratos')" class="fake-select" v-else>Seleccionar contrato</p>
                    <div class="options-container" v-if="showoptions['contratos']"
                        @mouseleave="closeOptions('contratos')">
                        <div class="check" v-for="tipo in dominiosorder.contratos">
                            <input type="checkbox" :id="'contrato-'+tipo[0]" v-model="filtros.contratos"
                                :value="tipo[0]" name="contrato">
                            <label :for="'contrato-'+tipo[0]">{{tipo[1]}}
                                ({{lengthbydomain['contratos'][tipo[0]]}})</label>
                        </div>
                    </div>
                </div>


                

                <div class="select column-start">
                    <label for="fechapublicacion">Fecha de publicacion</label>
                    <select name="" id="fechapublicacion" v-model="filtros.fechapublicacion"
                        :selected="!!filtros.fechapublicacion">
                        <option :value="fecha.value" v-for="(fecha,key) in fechas">{{fecha.label}} ({{lengthbydomain['fechapublicacion'][key]}})</option>
                    </select>
                </div>

                <div class="select column-start">
                    <label for="palabrasclave">Palabras clave</label>
                    <input type="text" id="palabrasclave" placeholder="Palabras de búsqueda"
                        v-model="filtros.palabrasclave" :selected="!!filtros.palabrasclave">
                </div>

            </div>



        </template>

        <div class="tags row-start" v-if="Object.values(filtros).some(f => f.length != 0)">

            <template v-for="(filtro,key) in filtrosstring">

                <a class="tag" v-if="!!filtro && typeof filtro == 'string'" @click="erasefiltro(key)">{{filtro}}
                    <i>✕</i></a>

                <template v-if="!!filtro && typeof filtro == 'object'">
                    <a class="tag" v-for="(el,pos) in filtro" @click="erasefiltroarray(el,key)">{{el}} <i>✕</i></a>
                </template>
            </template>

            <a class="link" @click="erasefiltros">Borrar todo</a>

        </div>


        <div class="progress-container" v-if="!!ofertas" :complete="ofertas.length >= nOfertas">
            <span class="progress" :style="'width:'+ofertas.length * 100 / nOfertas+'%'"></span>
            <span class="percent">{{Math.ceil(ofertas.length * 100 / nOfertas)}}%</span>
        </div>

    </section>

</template>

<script lang="js">

    import { mapGetters } from 'vuex';


    import router from '@/router';

    export default {
        name: 'buscador-ofertas',
        props: ['length', 'lengthbydomain'],
        data() {
            return {
                showfull: false,
                filtros: {
                    areafuncional: [],
                    sectores: [],
                    ubicacion: [],
                    contratos: [],
                    experiencia : [],
                    fechapublicacion: '',
                    palabrasclave: '',
                },
                showoptions: {
                    contratos: false,
                    ubicacion: false,
                    sectores: false,
                    areafuncional: false,
                    experiencia : false,
                }
            }
        },
        mounted() {


            if (Object.values(this.$route.query).length) {

                for (let filtro in this.$route.query) {
                    if(filtro != 'palabrasclave'){
                    this.filtros[filtro].push(this.$route.query[filtro]);
                }else{
                    this.filtros[filtro] = this.$route.query[filtro];
                }
                }

                router.replace({name : 'ofertas'})
                
            }else if (!!window.sessionStorage.getItem('filtro')) {
                this.filtros = JSON.parse(window.sessionStorage.getItem('filtro'));
                this.set();
            }

        },
        methods: {
            erasefiltro(key) {
                this.filtros[key] = '';
            },
            erasefiltroarray(key, id) {

                if (!!this.dominiosorder[id]) {

                    let toerase = this.dominiosorder[id].find(d => {
                        return (d[1] == key)
                    })[0];

                    this.filtros[id] = this.filtros[id].filter(f => f != toerase);

                }
            },
            set() {
                this.$emit('set', this.filtros);
            },
            erasefiltros() {
                for (let i in this.filtros) {
                    this.filtros[i] = (typeof this.filtros[i] == 'object') ? [] : '';
                }
                this.set();
                window.sessionStorage.removeItem('filtro');
                router.replace({name : 'ofertas'})
            },

            closefiltro() {
                this.erasefiltros();
                this.showfull = false;
            },
            toggleOptions(value) {

                for(let i in this.showoptions){
                    (i != value) ? this.showoptions[i] = false : null;
                }

                this.showoptions[value] = !this.showoptions[value];
            },
            closeOptions(value) {
                if(!('ontouchstart' in window )){
                    this.showoptions[value] = false;
                }
            }
        },
        computed: {
            ...mapGetters({
                dominios: 'getDominios',
                ubicaciones: 'getubicaciones',
                nOfertas : 'getNofertas',
                ofertas : 'getOfertas',
                hasExperiencias : 'hasExperiencias'
            }),
            dominiosorder() {
                let dominios = new Object();
                if (!!this.dominios) {

                    let toorder = ['areafuncional', 'sectores', 'contratos','experiencia'];
                    toorder.forEach(e => {
                        let tipos = Object.entries(this.dominios[e]);
                        dominios[e] = tipos.sort(function (p1, p2) {
                            return (p1[1] < p2[1]) ? -1 : 1;
                        })
                    });

                }

                return dominios;
            },
            filtroslength() {
                let length = 0;
                if (!!this.filtros) {
                    for (let i in this.filtros) {
                        if (this.filtros[i].length != 0) {
                            length++;
                        }
                    }
                }
                return length;
            },
            filtrosstring() {

                let domsearch = ['contratos', 'sectores', 'areafuncional','experiencia'];

                let filtros = new Object();

                for (let i in this.filtros) {

                    if (i == 'fechapublicacion' && !!this.filtros[i]) {

                        filtros[i] = Object.values(this.fechas).filter(t => t.value == this.filtros[i])[0].label;

                    } else {

                        if (domsearch.some(e => e == i)) {

                            filtros[i] = new Array();

                            this.filtros[i].forEach(f => {
                                filtros[i].push(this.dominios[i][f])
                            });

                        } else {
                            filtros[i] = this.filtros[i];
                        }

                    }
                }



                return filtros;

            },
            fechas() {
                let actual = new Date().getTime();
                const SEMANAVAL = 604800000;

                return {
                    "actual": {
                        "label": "Cualquier fecha",
                        "value": ''
                    },
                    "semana": {
                        "label": "Últimos 7 días",
                        "value": (actual - SEMANAVAL)
                    },
                    "quincena": {
                        "label": "Últimos 15 días",
                        "value": (actual - SEMANAVAL * 2)
                    },
                    "mes": {
                        "label": "Último mes",
                        "value": (actual - SEMANAVAL * 4)
                    },
                }

            }
        },
        filters: {
            list(value) {
                return value.join(", ");
            }
        },
        watch: {
            'filtros': {
                handler(newVal, oldVal) {
                    sessionStorage.setItem('filtro', JSON.stringify(this.filtros));
                    this.set();
                },
                deep: true,
            },
        }


    }
</script>

<style scoped lang="scss">

.ofertas-view .buscador .bottom .select{
    max-width: 100%;
}

.ofertas-view .buscador .bottom .select select, .ofertas-view .buscador .bottom .select input{
    max-width: 100%;
}

</style>


// WEBPACK FOOTER //
// src/components/parts/buscador-ofertas.vue